// extracted by mini-css-extract-plugin
module.exports = {"container":"_d7f2d37","icon":"_6450d3d"};